import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { NumberUtils } from "abweb/utils/NumberUtils";
import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DataSourceValueNumberBase } from "abweb/dto/generated/ds/DataSourceValueNumberBase";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceValueNumber extends DataSourceValueNumberBase {
  /**
   * Simplified factory method for creating a DataSourceValueNumber in a NORMAL state with no baseline.
   * @param id
   * @param value
   * @param refID
   * @returns {DataSourceReference}
   */
  static createWithReadOnlyDefaults(id, value, refID = null) {
    return DataSourceValueNumber.createDataSourceValueNumber(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, id, /*baselineRefID*/null, refID, /*state*/DataSourceState.NORMAL, /*baseline*/null, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
  }
  static createDataSourceValueNumber(attributeValues, clientTag, dataSourceSaveAction, id, baselineRefID, refID, state, baseline, value, editableOverwrite = null, fieldTypeOverwrite = null) {
    const retVal = new DataSourceValueNumber();
    retVal.initDataSourceValueNumber(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, null, value);
    return retVal;
  }
  constructor() {
    super();
  }
  initDataSourceValueNumber(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value) {
    super.initDataSourceValueNumber(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value);
    if (currentValue == null) {
      this.currentValue = value;
    }
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.value;
  }
  getBaseline() {
    return this.baseline;
  }
  get isNumber() {
    return true;
  }
  getDisplayValue() {
    const value = this.get("currentValue");
    return this.getFormattedValue(value);
  }
  getFormattedValue(value) {
    return value == null ? "" : NumberUtils.formatValue(Number(value));
  }
  isEmpty() {
    return !this.hasValue(this.getCurrentValue());
  }
  hasValue(value) {
    if (value == null) {
      return false;
    }
    return !isNaN(value);
  }
  validateValue(value) {
    const x = value == null ? NaN : value;
    if (!this.hasValue(x)) {
      if (this.isRequired()) {
        // Requiredness error
        return AbWebResources.required();
      } else {
        // There is no need to validate an empty value if it's not required.
        return null;
      }
    }
    const error = super.validateValue(value);
    if (error != null) {
      return error;
    }
    if (this._field == null || this._field.validation == null) {
      // Nothing to validate
      return null;
    }
    const validation = this._field.validation;
    if (this.hasValue(validation.rangeMin)) {
      if (x < validation.rangeMin) {
        return AbWebResources.rangeMinValidation(validation.rangeMin.toString());
      }
    }
    if (this.hasValue(validation.rangeMax)) {
      if (x > validation.rangeMax) {
        return AbWebResources.rangeMaxValidation(validation.rangeMax.toString());
      }
    }
    return null;
  }
  coerceValue(value) {
    if (value == null) {
      return null;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      if (value.isReference) {
        throw new Error("Cannot coerce a REFERENCE value to DECIMAL");
      }
      value = value.getCurrentValue();
    }
    if (value == null) {
      return null;
    }
    const t = typeof value;
    if (t === "number") {
      return value;
    }
    if (t === "string") {
      const x = parseFloat(value);
      if (isNaN(x)) {
        throw new Error(`Cannot coerce '${value}' into a number`);
      }
      return x;
    }
    if (t === "boolean") {
      return value ? 1 : 0;
    }
    if (ClassUtils.isInstanceOf(value, Date)) {
      return value.getTime();
    }
    return null;
  }
  initializeWithDefaultFieldValue(field) {
    if (field.defaultValue == null) {
      return;
    }
    const defaultValue = this.coerceValue(field.defaultValue);
    this.value = this.currentValue = defaultValue;
  }

  /**
   * Compare function that can be used for sorting.
   * @param bvalue Value to compare against.
   * @return negative number if this value is less than bvalue,
   * positive number if bvalue is less than this value, 0 if equal.
   */
  compare(bvalue) {
    let bn = bvalue;
    let a = this.currentValue;
    let b = bn == null ? null : bn.currentValue;
    if (a == null && b == null) {
      return 0;
    }
    if (a == null) {
      // null goes at front
      return -1;
    } else if (b == null) {
      return 1;
    }
    if (isNaN(a) && isNaN(b)) {
      return 0;
    }
    if (isNaN(a)) {
      // NaN goes at end
      return 1;
    } else if (isNaN(b)) {
      return -1;
    }
    return a - b;
  }
}
//# sourceMappingURL=DataSourceValueNumber.js.map
